import * as React from "react";
import { Slot } from "@radix-ui/react-slot";
import { cn } from "@/lib/utils";
import { faInfoCircle } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

export interface TextAreaProps extends React.HTMLAttributes<HTMLDivElement> {
  asChild?: boolean;
  id: string;
  placeholder: string;
  prefix?: string;
  title?: string;
  titleClassName?: string;
  divClassName?: string;
  value?: string;
  onChange: React.FormEventHandler;
  showError?: boolean;
  showFormatError?: boolean;
}

const TextArea = React.forwardRef<HTMLDivElement, TextAreaProps>(
  (
    {
      className,
      asChild = false,
      id,
      placeholder,
      prefix,
      title,
      titleClassName,
      divClassName,
      value,
      onChange,
      children,
      showError,
      showFormatError,
      ...props
    },
    ref
  ) => {
    const Comp = asChild ? Slot : "div";

    return (
      <Comp className={divClassName} ref={ref} {...props}>
        {title == null ? (
          <></>
        ) : (
          <p
            className={cn(
              `mb-2 ${showError ? "text-red-500" : ""}`,
              titleClassName
            )}
          >
            {title}
          </p>
        )}
        <div
          className={cn(
            `border-[1px] ${showError ? "border-red-500" : "border-gray-300"} rounded-md p-2 flex`,
            className
          )}
        >
          {prefix == null ? <></> : <img src={prefix} />}
          <textarea
            id={id}
            className="ml-2 w-full outline-0 bg-transparent"
            placeholder={placeholder}
            value={value}
            onChange={onChange}
          ></textarea>
        </div>
        <div
          className={`text-xs ${showError ? "text-red-500" : "hidden"} font-medium flex flex-row items-center space-x-1 mt-1`}
        >
          <FontAwesomeIcon icon={faInfoCircle} />
          <span>{title?.replace("*", "")} {showFormatError ? "format is wrong" : "cannot be empty"}</span>
        </div>
      </Comp>
    );
  }
);

TextArea.displayName = "TextArea";

export { TextArea };
